var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('p',{staticClass:"text-h2 font-weight-light"},[_vm._v("Home")]),_c('v-btn',{on:{"click":_vm.testFbFunction}},[_vm._v("Test")])],1),_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('MapApp')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }